module.exports = __webpack_public_path__ + "static/beeldmerk-thin-fa25ac1a9f4e131f525a9c46e74277b6.svg";